export const GET_HOME = 'GET_HOME';
export const OPEN_POPUP = 'OPEN_POPUP';
export const REFRESH_HOME = 'REFRESH_HOME';
export const SET_POPUP_SHARE = 'SET_POPUP_SHARE';